import { Action, createReducer, on } from '@ngrx/store';

import { GlobalAuthAction } from '../actions';
import { GlobalAuthState } from '../states/auth.state';

const initialState: GlobalAuthState = {
  email: '',
  verified: false,
  token: '',
};

const authReducer = createReducer(
  initialState,
  on(GlobalAuthAction.SetEmail, (state, { email }) => ({ ...state, email })),
  on(GlobalAuthAction.SetVerified, (state, { verified }) => ({ ...state, verified })),
  on(GlobalAuthAction.SetToken, (state, { token }) => ({
    ...state,
    token,
  })),
  on(GlobalAuthAction.ResetAll, () => initialState)
);

export function GlobalAuthReducer(state: GlobalAuthState | undefined, action: Action) {
  return authReducer(state, action);
}
